import { Injectable } from '@angular/core';
import * as fs from 'file-saver';
import { UserSessionService } from './UserSession/user-session.service';
import { Observable } from 'rxjs';

/**
 * Servicio para generar archivops en formato JSON
 */
@Injectable({
  providedIn: 'root'
})
export class JsonExporterService {

  constructor(private userSessionService: UserSessionService) { }


  /**
   * Exporta un objeto como archivo json
   * @param nombre Nombre del archivo
   * @param obj Objeto
   */
  async exportJson(nombre: String, obj: any,company: string){
    const customentities = await this.promisify(this.userSessionService.getCachedCustomEntitiesFullList(company))
    const str = JSON.stringify((obj as [any]).map(f => {
      if(f.type=='customentity_list'){
        f.customEntityConfig.entityType = (customentities as [any]).find(e => e.id == f.customEntityConfig.entity).type
      }
      return f;
    }));
    const bytes = new TextEncoder().encode(str);


    const blob = new Blob([bytes], {
        type: "application/json;charset=utf-8"
    });

    fs.saveAs(blob, nombre + '_campos.json');
    }

    importJson(archivo: File): Promise<any>{

      return new Promise((resolve,reject) => {
        var reader = new FileReader();
        reader.onload = () => {
          try{
            resolve(JSON.parse(reader.result as string))
          }catch{
            reject("Error parsing")
          }



        };
        reader.readAsText(archivo);
      })


    }

      /**
   * @ignore
   * @param obser
   * @returns
   */
  async promisify(obser: Observable<any>){
    return new Promise(resolve => {
      obser.subscribe((v) => {
        resolve(v)
      })
    })
}

}
